var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"alt":"loading","src":require("../../../public/images/loading.gif")}}),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('loaders.loadingHeader')))]),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }